export default ['all', 'read', 'unread'];
